import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {SerialNumberContainerModel} from '../../../../../models/aggregates/serial-number';


@Injectable({
  providedIn: 'root'
})
export class SerialNumberService extends BaseApiTemplateService<SerialNumberContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'serial-numbers';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'serial-numbers';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'serial-numbers';
    this.httpClient = http;
  }
}


